import { Injectable } from '@angular/core';
import { ApiConService } from '../shared/api-con.service';
import { JsonReturn } from '../interface/generic-interface';

@Injectable()
export class PopupNovaOcorrenciaService {

  constructor(private conService: ApiConService) { }

  async postCadastraOcorrencia(json): Promise<JsonReturn> {
    try {
      const response: JsonReturn = await this.conService.post('DCocorrencias', json);
      return response;
    }catch (Error) {
      console.log("CATCH________postCadastraOcorrencia");
      console.log(Error);
    }
  }

  async postCadastraOcorrenciaMsg(json) {
    try {
      const response = await this.conService.post('DCocorrenciaMensagem', json);
      return response[0];
    }catch (Error) {
      console.log("CATCH________postCadastraOcorrenciaMsg");
      console.log(Error);
    }
  }

  async getMotivoOcorrencia() {
    try {
      const response: JsonReturn = await this.conService.patch('DCmotivoOcorrencia');
      return response.response;
    }catch (Error) {
      console.log("CATCH________getMotivoOcorrencia");
      console.log(Error);
    }
  }

  async getOcorrencia(NumeroRoteiro) {
    try {
      const response: JsonReturn = await this.conService.patch('DCocorrencias/' + NumeroRoteiro);
      return response.response;
    }catch (Error) {
      console.log("CATCH________getOcorrencia");
      console.log(Error);
    }
  }
}